<template>
  <div>
    <table v-if="items && items.length">
      <thead>
        <tr>
          <th v-for="col in columnsToShow" :key="col.key">
            {{ col.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in items" :key="idx">
          <td v-for="col in columnsToShow" :key="col.key">
            {{ item[col.key] }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>No hay datos para mostrar.</div>
  </div>
</template>

<script>
export default {
  name: "List",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    columns: {
      type: Array,
      required: false,
      default: null,
    },
  },
  computed: {
    columnsToShow() {
      if (this.columns && this.columns.length) {
        return this.columns;
      }
      if (this.items.length) {
        return Object.keys(this.items[0]).map((key) => ({
          key,
          label: key,
        }));
      }
      return [];
    },
  },
};
</script>
